<!-- [formGroup]="matterdetailForm" -->
<form
  name="CommercialForm"
  id="CommercialForm"
  [formGroup]="CommercialForm"
  fxLayout="column"
  fxLayoutAlign="start"
  class="one"
  fxFlex="1 0 auto"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CLASSOFSHARES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CLASSOFSHARES),
      }"
    >
      <mat-label>Class of Shares</mat-label>
      <input
        matInput
        formControlName="CLASSOFSHARES"
        matTooltip="{{ toolTipList ? toolTipList.CLASSOFSHARES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.CLASSOFSHARES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CLASSOFSHARES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CLASSOFSHARES?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NUMBEROFSHARES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NUMBEROFSHARES),
      }"
    >
      <mat-label>Number of Shares</mat-label>
      <input
        matInput
        type="number"
        formControlName="NUMBEROFSHARES"
        matTooltip="{{ toolTipList ? toolTipList.NUMBEROFSHARES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.NUMBEROFSHARES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.NUMBEROFSHARES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.NUMBEROFSHARES?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="pr-1">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CONSIDERATION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CONSIDERATION),
      }"
    >
      <mat-label>Consideration</mat-label>
      <input
        matInput
        formControlName="CONSIDERATION"
        matTooltip="{{ toolTipList ? toolTipList.CONSIDERATION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.MATTERSTATUS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.MATTERSTATUS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.MATTERSTATUS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</form>
